/** Shared helpers for cheat sheet configuration filter mode (group_by=config). */

export const CHEAT_SHEET_CONFIG_ALL = "ALL";

export function isCheatSheetConfigFilterMode(selectedConfiguration: string): boolean {
  return selectedConfiguration.trim() !== "" && selectedConfiguration !== CHEAT_SHEET_CONFIG_ALL;
}

/** Reuse channel-mode column order with `tws` as the row label instead of `config`. */
export function mapConfigModeKeysUsingChannelOrder(
  keys: string[],
  orderChannelKeys: (channelKeys: string[]) => string[]
): string[] {
  const asChannel = keys.map((k) => (k.toLowerCase() === "tws" ? "config" : k));
  return orderChannelKeys(asChannel).map((k) => (k.toLowerCase() === "config" ? "tws" : k));
}

export function cheatSheetConfigModeColumnHeader(
  key: string,
  channelHeaders: Record<string, string>
): string {
  const kl = key.toLowerCase();
  if (kl === "record_count") return "Count";
  if (kl === "tws") return "TWS [KPH]";
  return channelHeaders[kl] ?? key;
}

/** Extract sorted unique CONFIG values from channel-mode cheat sheet rows. */
export function extractConfigurationOptionsFromRows(
  rowSets: Record<string, unknown>[][]
): string[] {
  const configs = new Set<string>();
  for (const rows of rowSets) {
    for (const row of rows) {
      const raw = row.config ?? row.CONFIG;
      if (raw != null && String(raw).trim() !== "") {
        configs.add(String(raw).trim());
      }
    }
  }
  return [...configs].sort((a, b) => a.localeCompare(b));
}
